import { createContext, useContext, useState, useEffect } from 'react';
import type { ReactNode } from 'react';
import { forexAPI } from '@/services/api';

interface ForexRatesState {
  rates: Record<string, number>;
  loading: boolean;
}

const FALLBACK_RATES: Record<string, number> = { India: 0.018, US: 1.55, UK: 1.95 };

const ForexRatesContext = createContext<ForexRatesState>({ rates: FALLBACK_RATES, loading: true });

export function ForexRatesProvider({ children }: { children: ReactNode }) {
  const [rates, setRates] = useState<Record<string, number>>(FALLBACK_RATES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchRates() {
      try {
        const data = await forexAPI.getRates();
        if (mounted && data.rates) {
          setRates(data.rates);
          setLoading(false);
        }
      } catch {
        if (mounted) setLoading(false);
      }
    }

    fetchRates();
    const id = setInterval(fetchRates, 300_000); // 5 min
    return () => { mounted = false; clearInterval(id); };
  }, []);

  return (
    <ForexRatesContext.Provider value={{ rates, loading }}>
      {children}
    </ForexRatesContext.Provider>
  );
}

export function useForexRates(): ForexRatesState {
  return useContext(ForexRatesContext);
}
